// extracted by mini-css-extract-plugin
export default {"logo":"Logout_logo__39zsk","logout":"Logout_logout__cPlRg","container":"Logout_container__odS-U","card":"Logout_card__YMJlz","button":"Logout_button__Rw5up"};